"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = convertFromMegaByteToByte;
/**
 * Converts a value from megabytes to bytes.
 *
 * @param {number} megaByte - The value in megabytes to be converted.
 * @returns {number} The converted value in bytes.
 */
const BYTES_IN_A_MEGABYTE = 1024 * 1024;
function convertFromMegaByteToByte(megaByte) {
  return megaByte * BYTES_IN_A_MEGABYTE;
}